import { createSvgIcon } from "@mui/material";

export const VectorDataBorthAndDeath = createSvgIcon(
  <rect width="16" height="2" rx="1" fill="#7F7F7F" />,
  'Vector',
);